'use client';
import { useEffect, useState } from 'react';

import { modalObservable } from './modal-observable';
import { ModalType } from './types';

export function ModalContainer() {
  const [modals, setModals] = useState<ModalType[]>([]);

  useEffect(() => {
    const sub = modalObservable.subscribe((md) => {
      setModals(md);
    });

    return () => {
      modalObservable.unsubscribe(sub);
    };
  }, []);

  return (
    <>
      {modals.map((modal) => (
        <modal.Component key={modal.id} data={modal.data} close={modal.close} />
      ))}
    </>
  );
}
